class Datajet extends HTMLElement {
  constructor() {
    super()
  }

  addCustomerTag(customerId, ListId) {
    const data = JSON.stringify({
      "customerID": `gid://shopify/Customer/${customerId}`,
      "listID": ListId
    });

    fetch('https://salomon.com.au/apps/datajet/task/66b1c1f8d7353f9cd96dd1d0', {
      method: "POST",
      headers: {
        "Content-Type": "application/json"
      },
      body: data
    })
    .then((response) => response.json())
    .then((result) => console.log(result))
    .catch((error) => console.error(error))
  }
}

customElements.define("datajet-task", Datajet)